import * as React from 'react';
import './HeightControl.css';

interface Props {
	elements?: React.ReactNode;
	showMore?: React.ReactNode;
	header?: string;
	onClickMore?: () => void;
}

const HeightControl: React.FunctionComponent<Props> = props => {
	const wrapperRef = React.useRef<HTMLDivElement>(null);
	const innerRef = React.useRef<HTMLDivElement>(null);
	const [showMore, setShowMore] = React.useState(false);
	const [open, setOpen] = React.useState(false);

	const updateHeight = () => {
		const wrapperHeight = wrapperRef.current.offsetHeight,
			firstChild = innerRef.current.childNodes.length > 0 ? innerRef.current.firstElementChild as HTMLDivElement : null;
		
		if (firstChild) {
			const firstChildHeight = firstChild.offsetHeight,
				childsCount = innerRef.current.childNodes.length;
					
			if (firstChildHeight * childsCount > (wrapperHeight - 50) && childsCount > 1) {
				const minCount = Math.round(wrapperHeight * 1.0 / firstChildHeight - 1);
				wrapperRef.current.classList.add('height-control_withHidden');

				setShowMore(true);

				innerRef.current.childNodes.forEach((child, key) => {
					if (key > minCount) {
						(child as HTMLDivElement).classList.add('hidden_element');// = 'none';
					}
					else {
						(child as HTMLDivElement).classList.remove('hidden_element'); //= 'flex';
					}
				})
			}
			else {
				setShowMore(false);
				wrapperRef.current.classList.remove("height-control_withHidden");
			}
		}
	};

	React.useEffect(() => {
		window.addEventListener("resize", updateHeight);

		if (wrapperRef.current) {
			updateHeight();
		}

		return () => {
			return window.removeEventListener('resize', updateHeight);
		}
	}, [wrapperRef]);

	return <div className="height-control" ref={wrapperRef} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
		<div className="height-control__wrapper" ref={innerRef} style={{ flex: '1' }}>
			{props.children}
		</div>

		{showMore && <div className="height-control__showMore" onClick={props.onClickMore}>
			{props.showMore}
		</div>}
	</div>;
};

export default HeightControl;